import "./styles/pilotage.css";

import { useEffect, useState } from "react";
import { PageStates } from "../../services/SystemNames";
import { PageStateCurrent } from "./components/PilotagesPageStates";
import AllPilotagesBottomMenu from "./components/AllPilotagesBottomMenu";
import FavouriteStations from "../../components/layout/favourite_stations/FavouriteStations";
import { AppContainerContent } from "../../components/layout/app/AppContainerContent";
import { useHeader } from "../../components/hooks/useHeader";

function All() {

    const [pageState, setPageState] = useState(PageStates.Default);

    useHeader("Alle oppdrag");

    useEffect(() => {
        return () => {};
    }, []);

    return (
        <AppContainerContent
            bottomMenu={<AllPilotagesBottomMenu
                pageState={pageState}
                onClick={handleTabChanged}
            />}>
            {(() => {
                switch (pageState) {
                    case PageStates.Default:
                        return (<PageStateCurrent />);
                    case PageStates.PilotStationSelector:
                        return (<FavouriteStations />);
                    default:
                        return null;
                }
            })()}
        </AppContainerContent>
    );

    async function handleTabChanged(newState) {
        setPageState(newState);
    }
}

export default All;
